import { $ } from "./$.module";
import { getFragment } from "./get-fragment.module";

const defaultOptions = {
	replace: true,
    classNames: {
        modal: 'modal',
        modalContent: 'modal-content',
        modalClose: 'modal-close',
        modalBackdrop: 'modal-backdrop',
		previous: 'modal-previous',
		next: 'modal-next',
    },
	id: 'modal',
}


const modal = (content, options) => {

    const classNames = {
        ...defaultOptions.classNames,
        ...options?.classNames,
    }
    options = {
        ...defaultOptions,
        ...options,
        classNames: classNames
    }


	window.modalOptions = options;

	const fill = (m, content) => {
		content = getFragment(content);
		const contentArea = $(`.${options.classNames.modalContent}`, m);

		if (options.replace) {
			contentArea.textContent = '';
		}
		contentArea.appendChild(content)


	}

	const get = () => {
		if (options.replace) {
			m = document.getElementById(options.id);
		}
		if (!m) {
			m = getFragment(`
				<div class="${options.classNames.modal}">
					<div class="${options.classNames.modalBackdrop}"></div>
					<div class="${options.classNames.modalClose}"></div>
					<div class="${options.classNames.modalContent}"></div>
				</div>
			`).children[0];
			m.id=options.id;
		}
	}

    const create = (content, parent = document.body) => {
		get();
		fill(m, content);
        const ret = parent.appendChild(m);
        ret.destroy = destroy

        ret.addEventListener('click', onClick);
        ret.addEventListener('wheel', onWheel);
        document.addEventListener('keydown',onKeydown);
		refresh();

        return ret;
    }

    const destroy = () => {
        m.setAttribute('destroy', 'destroy');
        m.addEventListener('animationend', onAnimationEnd)
    }

    const onAnimationEnd = e => {
        if (m.getAttribute('destroy') == 'destroy') {
            m.remove();
        }
        m.removeEventListener('click', onClick);
        m.removeEventListener('wheel', onWheel);
        document.removeEventListener('keydown',onKeydown);
    }

	const refresh = () => {
		console.log('refresh')
		options.next = $(options.origin.dataset.modalNextSelector);
		options.previous = $(options.origin.dataset.modalPreviousSelector);
		if (options.next) {
			m.classList.add('has-next');
		} else {
			m.classList.remove('has-next');
		}
		if (options.previous) {
			m.classList.add('has-previous');
		} else {
			m.classList.remove('has-previous');
		}
	}

	const previous = () => {
		if (options.previous) {
			fill(m, options.previous)
			options.origin = options.previous.closest('[modal]');
			refresh();
		}
	}

	const next = () => {
		if (options.next) {
			fill(m, options.next)
			options.origin = options.next.closest('[modal]');
			refresh();
		}
	}

    const onClick = e => {
        if (e.target.closest(`.${options.classNames.modalBackdrop}`) || e.target.closest(`.${options.classNames.modalClose}`)) {
			m.destroy();
		}
		if (e.target.closest(`.${options.classNames.next}`)) {
			next();
		}
		if (e.target.closest(`.${options.classNames.previous}`)) {
			previous();
		}

    }

    const onWheel = e => {
        if (e.target.closest(`.${options.classNames.modal}`)) {
            e.cancelBubble = true
            e.preventDefault();
            e.stopPropagation();
        }
    }

    const onKeydown = e => {
        if(e.key === "Escape") {
			m.destroy()
        }
		if(e.key === "ArrowRight") {
			next();
		}
		if(e.key === "ArrowLeft") {
			previous();
		}

    }


	let m;
    m = create(content)
    return m
}
export {modal}
